import $ from "dabbyjs/src/core/dabby/dabby.js";
import copy from "../../../swgfl/javascript/copy.js";

export default () => {
	copy($(".apikeys__copy"));
};